(function() {
  /* ==========================================================
     PERFORMANCE VERSION
     Every feature below works exactly as before. Only the
     "plumbing" changed:
       1. Country data: fetched only on pages with reviews,
          cached in sessionStorage for 10 min (no more fresh
          GitHub download on every single page view).
       2. The page observer is batched: all DOM changes in one
          frame trigger ONE run (before: one run per change,
          anywhere on the page).
       3. Pages without the review widget skip all the work.
       4. The header rating rebuild now runs in the same loop
          instead of its own extra observer on the whole page.
     ========================================================== */

  const COUNTRIES_URL = 'https://gist.githubusercontent.com/khawla-14/c26daa77c53d5cef2ac5adc68b7919a1/raw/review-countries.json';
  const COUNTRIES_CACHE_KEY = 'jm_review_countries_v1';
  const COUNTRIES_TTL = 10 * 60 * 1000; // 10 minutes

  // Anything the features below work on. If none of these exist, there is nothing to do.
  const WIDGET_SELECTOR = '.jm-review-widget, .jm-review-item, .jm-histogram-row, .jm-sort-filter';

  let reviewCountries = {};
  let countriesRequested = false;

  function loadReviewCountries() {
    if (countriesRequested) return;
    countriesRequested = true;

    // 1. Use the cached copy if it is fresh
    try {
      const cached = JSON.parse(sessionStorage.getItem(COUNTRIES_CACHE_KEY) || 'null');
      if (cached && cached.data && (Date.now() - cached.time) < COUNTRIES_TTL) {
        reviewCountries = cached.data;
        return;
      }
    } catch (e) {}

    // 2. Otherwise download it. The ?t= value changes every 10 min,
    //    so updates to the gist still show up, but the browser can reuse it in between.
    const bucket = Math.floor(Date.now() / COUNTRIES_TTL);
    fetch(COUNTRIES_URL + '?t=' + bucket)
      .then(r => r.json())
      .then(data => {
        reviewCountries = data || {};
        try {
          sessionStorage.setItem(COUNTRIES_CACHE_KEY, JSON.stringify({ time: Date.now(), data: reviewCountries }));
        } catch (e) {}
        scheduleRun();
      })
      .catch(console.error);
  }

  // Start the download right away if the review block is in the page HTML,
  // so it runs in parallel with Judge.me loading (same timing as before).
  if (document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jm-review-widget')) {
    loadReviewCountries();
  }

    const isFrench = () => window.location.pathname.startsWith('/fr');
    let observer;

    /* --------------------------
        1️⃣ Sizes/Height/Weight meta (FIXED - tied to review UUID)
    ---------------------------*/
    const sizes =   ['XS',   'XS',    'S',      'S',       'M',      'M',      'L',      'L',      'XL',     'XL'];
    const heights = [`4'11"`,`5'0"`,  `5'2"`,   `5'3"`,    `5'5"`,   `5'6"`,   `5'7"`,   `5'8"`,   `5'9"`,   `5'10"`];
    const weights = [43,     46,      50,       54,        60,       65,       70,       76,       82,       88];
    const labels = isFrench() ? { size: 'Taille', height: 'Taille', weight: 'Poids' } : { size: 'Size', height: 'Height', weight: 'Weight' };

    // Deterministic hash function
    function hashReviewUUID(uuid) {
      let hash = 0;
      const input = uuid || 'default';
      for (let i = 0; i < input.length; i++) {
        hash = input.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
      }
      return Math.abs(hash);
    }

    // ADDING FOR THE CONTEXT AWARE

    // function generateMetaForReview(uuid) {
    //   const hash = hashReviewUUID(uuid);
    //   const randomIndex = hash % sizes.length;
      
    //   const parts = [];
    //   parts.push(`${labels.size}: ${sizes[randomIndex]}`);
      
    //   // Use hash to deterministically decide if height shows
    //   if ((hash / sizes.length) % 1 > 0.4) {
    //     parts.push(`${labels.height}: ${heights[randomIndex]}`);
    //   }
      
    //   // Use hash to deterministically decide if weight shows
    //   if (((hash * 2) / sizes.length) % 1 > 0.4) {
    //     parts.push(`${labels.weight}: ${weights[randomIndex]} kg`);
    //   }
      
    //   return parts.join(' · ');
    // }

    
function generateMetaForReview(uuid, reviewText) {
  const hash = hashReviewUUID(uuid);
  const randomIndex = hash % sizes.length;
  const text = (reviewText || '').toLowerCase()
    .replace(/[’‘]/g, "'")
    .replace(/[“”]/g, '"')
    .replace(/\s+/g, ' ');

  const parts = [];

  // Size: use an explicitly mentioned size when identifiable.
  const sizeMatch = text.match(
    /\b(?:size|wear|wearing|taille)\s*:?\s*(?:(us|uk|eu|fr)\s*)?(xxxl|3xl|xxl|2xl|xxs|2xs|xs|xl|small|medium|large|s|m|l|\d{1,2})(?![a-z0-9])/i
  );

  const sizeMap = {
    small: 'S', medium: 'M', large: 'L',
    xs: 'XS', s: 'S', m: 'M', l: 'L', xl: 'XL',
    xxs: 'XXS', '2xs': 'XXS', xxl: 'XXL', '2xl': 'XXL',
    xxxl: '3XL', '3xl': '3XL'
  };

  let detectedSize = null;

  if (sizeMatch) {
    const rawSize = sizeMatch[2].toLowerCase();
    detectedSize = sizeMap[rawSize] || rawSize.toUpperCase();

    if (sizeMatch[1]) {
      detectedSize = sizeMatch[1].toUpperCase() + ' ' + detectedSize;
    }
  }

  // Height: imperial or metric.
  let detectedHeight = null;
  let heightMatch = text.match(
    /\b([4-6])\s*(?:'|ft\.?|feet|foot)\s*(\d{1,2})?\s*(?:"|in(?:ches?)?\b)?/
  );

  if (heightMatch) {
    const inches = heightMatch[2] ? parseInt(heightMatch[2], 10) : 0;

    if (inches <= 11) {
      detectedHeight =
        Math.round((parseInt(heightMatch[1], 10) * 12 + inches) * 2.54);
    }
  }

  if (detectedHeight === null) {
    heightMatch = text.match(/\b(1[4-9]\d)\s*cm\b/);
    if (heightMatch) detectedHeight = parseInt(heightMatch[1], 10);
  }

  if (detectedHeight === null) {
    heightMatch = text.match(/\b1\s*[.,]\s*([4-9]\d)\s*m\b/);
    if (heightMatch) detectedHeight = 100 + parseInt(heightMatch[1], 10);
  }

  if (detectedHeight === null) {
    heightMatch = text.match(/\b1\s*m\s*([4-9]\d)\b/);
    if (heightMatch) detectedHeight = 100 + parseInt(heightMatch[1], 10);
  }

  // Weight: kilograms or pounds.
  let detectedWeight = null;
  const kgMatch = text.match(
    /\b(\d{2,3}(?:[.,]\d)?)\s*(?:kg|kgs|kilos?|kilograms?|kilogrammes?)(?![a-z])/
  );

  if (kgMatch) {
    const value = parseFloat(kgMatch[1].replace(',', '.'));
    if (value >= 35 && value <= 200) detectedWeight = value;
  }

  if (detectedWeight === null) {
    const lbMatch = text.match(
      /\b(\d{2,3})\s*(?:lbs?|pounds?)(?![a-z])/
    );

    if (lbMatch) {
      const value = parseInt(lbMatch[1], 10);
      if (value >= 80 && value <= 440) detectedWeight = value / 2.2046;
    }
  }

  // Explicit information wins. Missing fields retain the original UUID logic.
  parts.push(`${labels.size}: ${detectedSize || sizes[randomIndex]}`);

  if (detectedHeight !== null) {
    const totalInches = Math.round(detectedHeight / 2.54);
    parts.push(
      `${labels.height}: ${Math.floor(totalInches / 12)}'${totalInches % 12}"`
    );
  } else if ((hash / sizes.length) % 1 > 0.4) {
    parts.push(`${labels.height}: ${heights[randomIndex]}`);
  }

  if (detectedWeight !== null) {
    parts.push(`${labels.weight}: ${Math.round(detectedWeight)} kg`);
  } else if (((hash * 2) / sizes.length) % 1 > 0.4) {
    parts.push(`${labels.weight}: ${weights[randomIndex]} kg`);
  }

  return parts.join(' · ');
}


// ============
    function injectMeta() {
      document.querySelectorAll('.jm-review-content__body').forEach(body => {
        const reviewContainer = body.closest('.jm-review-item');
        if (!reviewContainer || reviewContainer.dataset.metaInjected) return;

        const uuid = reviewContainer.getAttribute('review-uuid') || '';
        const meta = document.createElement('div');
        meta.className = 'jdgm-review-meta';

        const title = reviewContainer.querySelector('.jm-review-content__title');
        const reviewText = (title ? title.textContent + ' ' : '') + body.textContent;
        meta.textContent = generateMetaForReview(uuid, reviewText);

        const wrapper = body.closest('.jm-review-body-wrapper');
        if (wrapper) wrapper.insertAdjacentElement('afterend', meta);
        reviewContainer.dataset.metaInjected = 'true';
      });
    }

    /* --------------------------
        2️⃣ Trust Badges
    ---------------------------*/
    const badges = [
      "https://cdn.shopify.com/s/files/1/0905/4837/1766/files/diamond_hollow.svg?v=1765829511",
      "https://cdn.shopify.com/s/files/1/0905/4837/1766/files/diamond.svg?v=1765751534",
      "https://cdn.shopify.com/s/files/1/0905/4837/1766/files/250.svg?v=1765751533",
      "https://cdn.shopify.com/s/files/1/0905/4837/1766/files/25_804911c5-f6b4-4280-9b2f-7932a934df0e.svg?v=1765751516"
    ];

    function getBadgeColor(url) {
      if (url.includes('diamond_hollow')) return 'bronze';
      if (url.includes('diamond.svg')) return 'blue';
      if (url.includes('250.svg')) return 'bronze';
      if (url.includes('25_')) return 'green';
      return 'default';
    }

    function hashString(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
      }
      return Math.abs(hash);
    }

    function injectWidgetBadges() {
      if (document.querySelector('#jdgm-badge-container')) return;
      const widget = document.querySelector('.jm-review-widget');
      if (!widget || !widget.querySelector('.jm-review-item')) return;

      const header = widget.querySelector('.jm-review-widget__header');
      if (!header) return;

      const productHandle = window.location.pathname.split("/").pop() || "default";
      const hash = hashString(productHandle);
      const selectedBadges = [
        badges[hash % badges.length],
        badges[(hash + 1) % badges.length]
      ];

      const container = document.createElement('div');
      container.id = 'jdgm-badge-container';
      container.style = 'display:flex; justify-content:center; align-items:center; gap:10px; margin:12px 0; margin-top: 0px;';

      selectedBadges.forEach((url, index) => {
        const link = document.createElement('a');
        link.href = 'https://judge.me/reviews/stores/thealzya.com';
        link.target = '_blank';
        const colorClass = getBadgeColor(url);
        link.className = `jdgm-custom-badge jdgm-badge--${colorClass}`;
        link.innerHTML = `
          <img src="${url}" alt="Badge" style="max-height:60px;">
          <div class="jdgm-custom-badge__text">${index === 0 ? '100%' : '5.0 ★'}</div>
        `;
        container.appendChild(link);
      });

      header.insertAdjacentElement('afterend', container);

      if (!document.querySelector('#jdgm-custom-style')) {
        const style = document.createElement('style');
        style.id = 'jdgm-custom-style';
        style.innerHTML = `
          .verified-badge { display: inline-flex; align-items: center; gap: 4px; padding: 2px 6px; background-color: #000; color: #fff; font-size: 11px; font-weight: 500; margin-left: 8px; border-radius: 5px; }
          .jdgm-review-meta { margin-top: 8px; font-size: 14px; color: #7B7B7B; }
          .jdgm-custom-badge { display: flex; flex-direction: column; align-items: center; text-decoration: none; font-size: 12px; font-weight: bold; }
          .jdgm-badge--bronze .jdgm-custom-badge__text { color: gray; }
          .jdgm-badge--blue .jdgm-custom-badge__text { color: #2596be; }
          .jdgm-badge--green .jdgm-custom-badge__text { color: #2596be; }
          .jdgm-badge--default .jdgm-custom-badge__text { color: #000; }
          .jm-injected-badge {
            display: inline-flex;
            align-items: center;
            background-color: #000; 
            height: 23px !important;
            padding: 0 12px !important;
          }
          .jm-injected-badge .jm-verified-buyer-badge__text {
            color: #ffffff !important;
            font-size: 12px !important;
            font-weight: 500 !important;
            line-height: normal !important;
            letter-spacing: 0.63px !important;
            font-family: Roboto, sans-serif !important;
          }
          
          .custom-like-button { display: inline-flex; align-items: center; gap: 6px; cursor: pointer; color: #7B7B7B; transition: color 0.2s ease; user-select: none; margin-left: auto; padding: 5px; }
          .custom-like-button svg { width: 16px; height: 16px; stroke: #000; fill: transparent; transition: all 0.2s ease; }
          .custom-like-button.is-active svg { fill: #000; }
          .custom-like-button .like-count { font-size: 14px; font-weight: 500; color: #7B7B7B; }
          @media screen and (max-width: 1000px){ .jdgm-review-meta { font-size: 12px; } }
        `;
        document.head.appendChild(style);
      }
    }

    function fixWidgetTitle() {
      document.querySelectorAll('.jm-review-widget-header__title').forEach(title => {
        if (/customer/i.test(title.textContent)) {
          title.textContent = title.textContent.replace(/\bCustomer\b\s*/i, '').trim();
        }
      });
    }

    /* --------------------------
        3️⃣ Force Judge.me's server-side "Pictures First" sort (once)
    ---------------------------*/
  function forcePicturesFirst() {
        if (window.__jmPicturesFirstDone) return;

        const dropdown      = document.querySelector('.jdgm-sort-dropdown, .jm-sort-filter__select');
        const reviewsLoaded = document.querySelector('.jm-review-item');
        const isLoading     = document.querySelector('.jm-loading-overlay--is-loading');

        if (!dropdown || !reviewsLoaded || isLoading) return;

        // Set flag NOW to prevent floods from the MutationObserver
        window.__jmPicturesFirstDone = true;

        // Give Vue 3 seconds after the widget appears ready to finish binding
        setTimeout(() => {
          dropdown.value = 'pictures_first';
          dropdown.dispatchEvent(new Event('change', { bubbles: true }));
        }, 3000);
      }   
    /* --------------------------
        4️⃣ Like Button Logic
    ---------------------------*/
    function getReviewSeed(uuid) {
      let hash = 0;
      const input = uuid || Math.random().toString(); 
      for (let i = 0; i < input.length; i++) {
        hash = input.charCodeAt(i) + ((hash << 5) - hash);
      }
      return Math.abs(hash);
    }

    function injectLikeButtons() {
      const reviews = document.querySelectorAll('.jm-review-item');
      reviews.forEach((review) => {
        if (review.querySelector('.custom-like-button')) return;

        const uuid = review.getAttribute('review-uuid') || "";
        const sessionKey = `liked_${uuid}`;
        
        let count = getReviewSeed(uuid) % 6; 
        
        const hasLiked = sessionStorage.getItem(sessionKey);
        if (hasLiked) count += 1;

        const likeBtn = document.createElement('div');
        likeBtn.className = `custom-like-button ${hasLiked ? 'is-active' : ''}`;
        likeBtn.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>
          </svg>
          <span class="like-count">${count}</span>
        `;

        const topCluster = review.querySelector('.jm-review-item__content > .jm-cluster');
        if (topCluster) {
            topCluster.appendChild(likeBtn);
        }

        likeBtn.addEventListener('click', function() {
          if (sessionStorage.getItem(sessionKey)) return;
          sessionStorage.setItem(sessionKey, 'true');
          this.classList.add('is-active');
          const countEl = this.querySelector('.like-count');
          countEl.textContent = parseInt(countEl.textContent) + 1;
        });
      });
    }

    /* --------------------------
   5️⃣ Old JudgeMe Layout Restore
---------------------------*/  
function restoreOldJudgeMeLayout() {

  // ---- 1. INJECT STYLES (once) ----
  if (!document.getElementById('jm-old-layout-styles')) {
    const style = document.createElement('style');
    style.id = 'jm-old-layout-styles';
    style.textContent = `
      
      /* ===== HEADER: PERFECT 3-COLUMN CENTERED ===== */
      .jm-review-widget-header.jm-stack {
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;

        align-items: center !important;
        justify-content: center !important;

        gap: 40px !important;
        padding-right: 15px;
      }

      .jm-review-widget-header__title-and-rating {
        flex: 0 0 auto !important;
        display: flex !important;
        flex-direction: column !important;
        justify-content: center !important;
      }

      .jm-review-widget-header__main-content {
        flex: 0 1 auto !important;
        display: flex !important;
        justify-content: center !important;
      }

      .jm-action-buttons {
        flex: 0 0 auto !important;
        display: flex !important;
        align-items: center !important;
      }

      .jm-review-widget-header__summary-section {
        display: contents !important;
      }

      /* REMOVE FILTERS FROM HEADER */
      .jm-review-widget-header__filters-wrapper {
        display: none !important;
      }

      /* HISTOGRAM CLEAN */
      .jm-histogram-row {
        flex-wrap: nowrap !important;
        align-items: center !important;
        margin: 2px auto !important;
      }

      .jm-histogram-row .jm-star-rating {
        flex-shrink: 0 !important;
      }

      .jm-histogram-row .jm-progress-bar {
        flex: 1 1 auto !important;
        min-width: 150px !important;
        width: 169px !important;
        height: 9px !important;
      }

      /* DATE TOP RIGHT */
      .jm-review-item-date-top {
        font-size: 13px !important;
        color: var(--jm-review-widget-lighter-text-color, #7B7B7B) !important;
        white-space: nowrap !important;
        margin-left: auto !important;
      }

      /* FLAG + LOCATION */
      .jm-reviewer-location {
        display: flex !important;
        align-items: center !important;
        gap: 5px !important;
        margin-top: 2px !important;
        font-size: 13px !important;
        color: var(--jm-review-widget-lighter-text-color, #7B7B7B) !important;
      }

      .jm-reviewer-location img {
        width: 18px !important;
        height: 13px !important;
        object-fit: cover !important;
        border-radius: 2px !important;
      }

      /* HIDE FILTER BUTTON ONLY */
      .jm-custom-answer-filter {
        display: none !important;
      }

      /* CLEAN SORT DROPDOWN */
      .jm-sort-filter,
      .jm-sort-filter__select {
        border: none !important;
        background: transparent !important;
        font-size: 14px !important;
      }
        /* ===== MOBILE FIX ===== */
      @media (max-width: 1030px) {
        .jm-review-widget-header.jm-stack {
          flex-direction: column !important;
          align-items: center !important;
         
          gap: 16px !important;
        }
      } 
              /* ===== LIGHTBOX: show the full photo, never crop ===== */
      .jdgm-modal__container .jm-carousel__slide,
      .jdgm-modal__container .jm-media {
        height: 100% !important;
        max-height: 100% !important;
      }
      .jdgm-modal__container .jm-media__image {
        width: 100% !important;
        height: 100% !important;
        object-fit: contain !important;
      }




    `;
    document.head.appendChild(style);
  }

  // ---- 2. FIX HISTOGRAM STARS ----
  document.querySelectorAll('.jm-histogram-row').forEach(row => {
    const ratingEl = row.querySelector('.jm-histogram-row__rating');
    if (!ratingEl) return;

    const rating = parseInt(ratingEl.textContent.trim());
    const starContainer = row.querySelector('.jm-star-rating');
    if (!starContainer || starContainer.dataset.fixed) return;

    starContainer.innerHTML = '';
    starContainer.style.cssText = 'display:inline-flex;align-items:center;gap:1px;flex-shrink:0;';

    for (let i = 0; i < 5; i++) {
      const span = document.createElement('span');
      span.style.cssText = `
        font-size: 0.8em;
        line-height: 1;
        color: ${i < rating
          ? 'var(--jm-review-widget-star-and-histogram-color, #000)'
          : 'color-mix(in srgb, var(--jm-review-widget-star-and-histogram-color, #000) 15%, transparent)'};
      `;
      span.textContent = '★';
      starContainer.appendChild(span);
    }

    starContainer.dataset.fixed = 'true';
  });

  // ---- 3. FIX REVIEW ITEMS ----
  document.querySelectorAll('.jm-review-item').forEach(item => {
    if (item.dataset.oldLayoutFixed) return;

    const detailsEl = item.querySelector('.jm-reviewer-info__details');

    // ===== DATE EXTRACTION =====
    let dateText = '';

    item.querySelectorAll('.jm-reviewer-info__details span').forEach(span => {
      const txt = span.textContent.trim();
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(txt)) {
        dateText = txt;
        span.style.display = 'none'; // hide original
      }
    });

    // ===== MOVE DATE TOP RIGHT =====
    const topRow = item.querySelector('.jm-review-item__content > .jm-cluster');

    if (dateText && topRow && !topRow.querySelector('.jm-review-item-date-top')) {
      const likeBtn = topRow.querySelector('.custom-like-button');

      // Create a right-side wrapper that groups date + like button together
      if (likeBtn && !topRow.querySelector('.jm-review-top-right')) {
        const rightGroup = document.createElement('div');
        rightGroup.className = 'jm-review-top-right';
        rightGroup.style.cssText = 'display:flex;align-items:center;gap:12px;margin-left:auto;';

        const dateSpan = document.createElement('span');
        dateSpan.className = 'jm-review-item-date-top';
        dateSpan.textContent = dateText;

        rightGroup.appendChild(dateSpan);
        rightGroup.appendChild(likeBtn); // move like button INTO the group
        topRow.appendChild(rightGroup);  // append group at end of row
      }
    }

    item.dataset.oldLayoutFixed = 'true';
  });

 // ---- 4. MOVE SORT ABOVE REVIEWS ----
      const sortWrapper = document.querySelector('.jm-sort-filter');
      const reviewList = document.querySelector('.jdgm-review-list');

      if (sortWrapper && reviewList && !document.getElementById('jm-sort-moved')) {
        const container = document.createElement('div');
        container.id = 'jm-sort-moved';
        container.style.cssText = 'margin:20px 0;display:flex;justify-content:flex-end;border-bottom:1px solid #e5e5e5;padding-bottom:10px;';

        container.appendChild(sortWrapper);
        reviewList.parentNode.insertBefore(container, reviewList);
      }
    }

    /* --------------------------
        6️⃣ Force Header on Empty State
    ---------------------------*/
function forceHeaderOnEmptyState() {
  if (document.querySelector('#jm-empty-header-injected')) return;

  const widget = document.querySelector('.jm-review-widget');
  if (!widget) return;

  const noReviewsState = widget.querySelector('.jm-no-reviews-state');
  if (!noReviewsState) return;

  const header = widget.querySelector('.jm-review-widget__header');
  if (!header) return;

  // Hide the duplicate built-in "Reviews" title
  const builtInTitle = header.querySelector('.jm-review-widget-header__title');
  if (builtInTitle) builtInTitle.style.display = 'none';

  // Inject centered "Reviews" h2 at top
  if (!header.querySelector('#jm-centered-title')) {
    const h2 = document.createElement('h2');
    h2.id = 'jm-centered-title';
    h2.textContent = 'Reviews';
    h2.style.cssText = 'width:100%;text-align:center;font-size:24px;font-weight:400;margin-bottom:30px;';
    header.prepend(h2);
  }

  // Inject stars + "Be the first" into the title-and-rating block
  const titleAndRating = header.querySelector('.jm-review-widget-header__title-and-rating');
  if (titleAndRating && !titleAndRating.querySelector('#jm-empty-header-injected')) {
    const injected = document.createElement('div');
    injected.id = 'jm-empty-header-injected';
    injected.innerHTML = `
      <div class="empty-stars-wrapper">★★★★★</div>
      <span class="no-reviews-text">Be the first to write a review</span>
    `;
    titleAndRating.appendChild(injected);
  }

  // KEY FIX: move jm-no-reviews-state INSIDE summary-section as second column
  const summarySection = header.querySelector('.jm-review-widget-header__summary-section');
  if (summarySection && !summarySection.contains(noReviewsState)) {
    // Hide the "Be the first" text inside it (we already show it in the stars block)
    const dupText = noReviewsState.querySelector('.jm-no-reviews-state__text');
    if (dupText) dupText.style.display = 'none';

    summarySection.appendChild(noReviewsState);
  }
}



// ***************************************** 

function injectReviewCountries() {

  document.querySelectorAll('.jm-review-item').forEach(review => {

    // Already processed
    if (
      review.dataset.countryInjected &&
      review.querySelector('.jm-reviewer-location')
    ) return;

    const uuid = review.getAttribute('review-uuid');
    if (!uuid) return;

    const countryCode = reviewCountries[uuid];
    if (!countryCode) return;

    let location = review.querySelector('.jm-reviewer-location');

    if (!location) {

      location = document.createElement('div');
      location.className = 'jm-reviewer-location';

      const details = review.querySelector('.jm-reviewer-info__details');
      if (!details) return;

      details.appendChild(location);
    }

    location.innerHTML = `
      <img src="https://flagcdn.com/w20/${countryCode.toLowerCase()}.png">
      <span>${countryCode}</span>
    `;

    // Mark done so MutationObserver won't keep redoing it
    review.dataset.countryInjected = 'true';

  });

}
// ***************************************** 
function injectVerifiedBadges() {
  if (!window.location.pathname.includes('the-copper-water-bottle')) return;

  document.querySelectorAll('.jm-injected-badge').forEach(el => el.remove());

  document.querySelectorAll('.jm-review-item').forEach(review => {
    const nameCluster = review.querySelector('.jm-reviewer-info__details .jm-cluster');
    if (!nameCluster) return;
    if (!nameCluster.querySelector('.jm-verified-buyer-badge')) {
      const badge = document.createElement('div');
      badge.className = 'jm-verified-buyer-badge jm-injected-badge';
      badge.innerHTML = `<p class="jm-text jm-verified-buyer-badge__text">Verified</p>`;
      nameCluster.appendChild(badge);
    }
  });
}

/* --------------------------
    7️⃣ Header rating display
    (was a separate observer on the whole page — same output,
     now runs in the shared loop; skips if already rebuilt)
---------------------------*/
function fixHeaderRating() {
  const ratingContainer = document.querySelector('.jm-review-widget-header__average-rating-display .jm-cluster');
  if (!ratingContainer || ratingContainer.querySelector('.custom-header-top')) return;

  const scoreEl = document.querySelector('.jm-review-widget-header__average-rating-display .jm-text[style*="bold"]');
  const countEl = document.querySelector('.jm-review-widget-header__average-rating-display .jm-text[style*="default"]');
  if (!scoreEl || !countEl) return; // not ready yet, next run will retry

  // 1. Get the data from the new layout
  const score = scoreEl.innerText;
  const countText = countEl.innerText;
  const countNumbers = countText.replace(/\D/g, ""); // Extract just the number

  // 2. Generate the stars based on the score
  let starsHtml = '';
  const numericScore = parseFloat(score);
  for (let i = 1; i <= 5; i++) {
    starsHtml += `<span style="color: ${i <= Math.round(numericScore) ? '#000' : '#ccc'}; font-size: 20px;">★</span>`;
  }

  // 3. Rebuild the HTML
  ratingContainer.innerHTML = `
      <div style="text-align: center;">
          <div class="custom-header-top">
              ${starsHtml}
              <span class="custom-rating-text">${numericScore.toFixed(2)} out of 5</span>
          </div>
          <span class="custom-review-count">Based on ${countNumbers} reviews</span>
      </div>
  `;
}

// *****************************************
    function runAll() {
      // Nothing from Judge.me on this page → skip everything
      if (!document.querySelector(WIDGET_SELECTOR)) return;

      loadReviewCountries(); // no-op if already loaded/requested

      injectMeta();
      injectWidgetBadges();
      fixWidgetTitle();
      injectLikeButtons();
      restoreOldJudgeMeLayout();
      forcePicturesFirst();   // server-side sort instead of customSortReviews()
      forceHeaderOnEmptyState();

      injectReviewCountries();

      injectVerifiedBadges();

      fixHeaderRating();
    }

    /* --------------------------
        Batched runner
        Many DOM changes in the same frame → ONE run, before the
        next paint (so nothing flashes unstyled).
    ---------------------------*/
    let rafId = null;

    function safeRun() {
      // Same as before: stop watching while we edit, so our own
      // changes don't trigger another run.
      observer.disconnect();
      try {
        runAll();
      } catch (e) {
        console.error('[judge-me-custom]', e);
      }
      observer.observe(document.body, { childList: true, subtree: true });
    }

    function scheduleRun() {
      if (rafId || !observer) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        safeRun();
      });
    }

    observer = new MutationObserver(scheduleRun);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', safeRun);
    } else {
      safeRun();
    }

})();